// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u4Ip","left":"styles_left__2sUYd"};